import React from "react";
import { connect } from "react-redux";
import { TransitionGroup, CSSTransition } from "react-transition-group";

import {
  isBasketEmpty,
  getBasketTotalPrice,
  getBasketTotalQuantity
} from "state/school_money/selectors";

import { NavLink } from "react-router-dom";

import Currency from "components/Currency";

import basketIcon from "components/assets/images/school_money/basket.svg";
import "./BasketButton.css";

class BasketButton extends React.Component {
  
  /*
   * NOTE: the `key` prop on CSSTransition is very important here.
   * TransitionGroup allows animating elements as they enter and leave.
   * When totalPrice changes, we want to animate the old price out and the new price in.
   * Using key={totalPrice} we ensure that the CSSTransition component is not reused.
   * So when totalPrice changes, a new CSSTransition will be mounted and the old one will be unmounted.
   * Due to the wrapping TransitionGroup, this allows both CSSTransition components to animate
   *   simultaneously (one in, one out).
   */
  render() {
    
    const { isEmpty, totalPrice, totalQuantity } = this.props;
    
    const basketState = isEmpty ? "empty" : "not-empty";
    
    return (
      <NavLink to="/school_money/basket/">
        <div className={`basket-button basket-button--${basketState}`}>
          <img className="basket-button__img" src={basketIcon} alt="basket" />
          <TransitionGroup>
            {
              !isEmpty ?
              <CSSTransition key={`${totalQuantity}:${totalPrice}`} classNames="basket-button__info" timeout={500}>
                <div className="basket-button__info">
                  <Currency className="basket-button__total-price" amount={totalPrice} />
                  <div className="basket-button__total-quantity">{totalQuantity}</div>
                </div>
              </CSSTransition> :
              null
            }
          </TransitionGroup>
        </div>
      </NavLink>
    );
    
  }
  
}

export default connect(
  state => ({
    isEmpty: isBasketEmpty(state),
    totalPrice: getBasketTotalPrice(state),
    totalQuantity: getBasketTotalQuantity(state)
  })
)(BasketButton);



// WEBPACK FOOTER //
// ./src/components/school_money/BasketButton.js